import { createContext, useContext, useState } from 'react';

const CredentialsContext = createContext();

export const CredentialsProvider = ({ children }) => {
  const [awsCredentials, setAwsCredentials] = useState(null);

  return (
    <CredentialsContext.Provider value={{ awsCredentials, setAwsCredentials }}>
      {children}
    </CredentialsContext.Provider>
  );
};

export const useAwsCredentials = () => useContext(CredentialsContext);